{
    "name": "addin-web",
    "version": "1.0.34-rc-2",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build:prod": "ng build --configuration=production && npm run write-version && npm run write-web-config",
        "build:dev": "ng build --configuration=development && npm run write-version && npm run write-web-config",
        "build:stage": "ng build --configuration=stage && npm run write-version && npm run write-web-config",
        "watch": "ng build --watch --configuration=production",
        "test": "ng test",
        "assemble-manifest": "node ./assemble-manifests.js",
        "generate-certificate": "npx office-addin-dev-certs install",
        "write-version": "node ./scripts/write-version.js",
        "write-web-config": "node ./scripts/write-web-config.js",
        "lint": "ng lint",
        "lint:fix": "ng lint --fix"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^17.0.0",
        "@angular/cdk": "^17.0.1",
        "@angular/cdk-experimental": "^17.0.1",
        "@angular/common": "^17.0.0",
        "@angular/compiler": "^17.0.0",
        "@angular/core": "^17.0.0",
        "@angular/forms": "^17.0.0",
        "@angular/material": "^17.0.1",
        "@angular/platform-browser": "^17.0.0",
        "@angular/platform-browser-dynamic": "^17.0.0",
        "@angular/router": "^17.0.0",
        "@listat/r2-core": "../r2-core",
        "@listat/r2-web-addin-functions": "../r2-web-addin-functions",
        "@messageformat/core": "^3.3.0",
        "@ng-select/ng-select": "^12.0.7",
        "@ngx-translate/core": "^15.0.0",
        "buffer": "^6.0.3",
        "marked": "^9.0.0",
        "ngx-indexed-db": "^16.0.0",
        "ngx-markdown": "^17.2.1",
        "ngx-translate-messageformat-compiler": "^6.5.0",
        "prismjs": "^1.28.0",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "uuid": "^9.0.1",
        "zone.js": "~0.14.2"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^17.0.1",
        "@angular-eslint/builder": "17.3.0",
        "@angular-eslint/eslint-plugin": "17.3.0",
        "@angular-eslint/eslint-plugin-template": "17.3.0",
        "@angular-eslint/schematics": "17.3.0",
        "@angular-eslint/template-parser": "17.3.0",
        "@angular/cli": "^17.0.1",
        "@angular/compiler-cli": "^17.0.0",
        "@types/jasmine": "~5.1.0",
        "@types/node": "^18.18.2",
        "@types/office-js": "^1.0.360",
        "@types/uuid": "^9.0.7",
        "@typescript-eslint/eslint-plugin": "7.2.0",
        "@typescript-eslint/parser": "7.2.0",
        "autoprefixer": "^10.4.16",
        "eslint": "^8.57.0",
        "jasmine-core": "~5.1.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "postcss": "^8.4.31",
        "tailwindcss": "^3.3.5",
        "typescript": "~5.2.2"
    },
    "engines": {
        "node": ">=18.18.0",
        "yarn": ">=1.22.19",
        "npm": ">=9.8.1"
    }
}
